import React, { FC } from 'react';

import { Account } from 'src/api/@generated/backend';

import { ChooseButton } from 'src/components/choose-button/choose-button';
import { i18n } from 'src/i18n';
import { buildingImageProps, personImageProps } from 'src/resources/images';
import { selectAccountActionCreator } from 'src/state/account/action-creators/select-account-action-creator';
import { selectPartnerListIfDefined } from 'src/state/request/selectors';
import { useAppDispatch, useAppSelector } from 'src/state/thunk-api';
import { I18nUtils } from 'src/utils/i18n-utils';
import { PartnerUtils } from 'src/utils/partner-utils';

import { StyledTitle } from './choose-account-button.styled';

interface Props {
  index: number;
  account: Account;
}

export const ChooseAccountButton: FC<Props> = (props) => {
  const {
    index,
    account: { partnerId, customerId, name },
  } = props;
  const partners = useAppSelector(selectPartnerListIfDefined);
  const dispatch = useAppDispatch();
  const partner = partners && PartnerUtils.getPartnerByPartnerId(partners, partnerId);

  return (
    <ChooseButton
      onClick={() => dispatch(selectAccountActionCreator(index))}
      key={customerId}
      items={[
        {
          text: I18nUtils.message(i18n.page.chooseAccount.button.customerNumber, { customerId }),
          icon: personImageProps,
          isValueSensitive: true,
        },
        ...(partner
          ? [
              {
                text: I18nUtils.message(i18n.page.chooseAccount.button.partner, { partnerName: partner.name }),
                icon: buildingImageProps,
              },
            ]
          : []),
      ]}
      title={
        <StyledTitle variant="paragraph2" component="p" data-hj-suppress={true}>
          {name}
        </StyledTitle>
      }
    />
  );
};
